import mutations from "./mutations.js";
import actions from "./actions.js";
import getters from "./getters.js";

export default {
  namespaced: true,
  state() {
    return {
      user: {
        id: localStorage.getItem("sianah_Dash_User_Id"),
        token: localStorage.getItem("sianah_Dash_Token"),
        usertype: localStorage.getItem("sianah_Dash_User_Type"),
        name: localStorage.getItem("sianah_Dash_User_name"),
        image: localStorage.getItem("sianah_Dash_userImg"),
        phone: localStorage.getItem("sianah_Dash_userPhone"),
        email: localStorage.getItem("sianah_Dash_userEmail"),
        gender: localStorage.getItem("sianah_Dash_userGender"),
      },
    };
  },
  mutations,
  actions,
  getters,
};
